<template>
  <div class="mine">
    <!-- 用户信息头部：已登录 -->
    <div class="user-header" v-if="loggedIn">
      <!-- 右上角设置齿轮图标：点击进入设置页（带loading） -->
      <svg viewBox="0 0 24 24" class="setting-icon" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" @click="goSettings">
        <circle cx="12" cy="12" r="3"/>
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
      </svg>
      <img src="@/assets/icons/mine-top-avatar.png" class="avatar-img" alt="头像" />
      <div class="user-detail" @click="goAccountInfo">
        <div class="name-row">
          <span class="name">**杰</span>
          <span class="real-tag" @click.stop="goCertification">
            <svg viewBox="0 0 24 24" class="tag-icon">
              <path d="M4 10.5 L12 4 L20 10.5 V20 H14.5 V14 H9.5 V20 H4 Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
              <circle cx="12" cy="11.5" r="2.2" fill="currentColor"/>
            </svg>
            已实人
          </span>
        </div>
        <div class="id-number">34**********19</div>
      </div>
      <!-- 用户信息行右侧箭头：进入账户信息（带loading） -->
      <svg viewBox="0 0 24 24" class="header-arrow" @click="goAccountInfo">
        <path d="M9 5 L16 12 L9 19" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <!-- 用户信息头部：未登录（请登录 + 登录/注册按钮） -->
    <div class="user-header header-logout" v-else>
      <svg viewBox="0 0 24 24" class="setting-icon" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" @click="goSettings">
        <circle cx="12" cy="12" r="3"/>
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
      </svg>
      <!-- 灰底白色人像占位头像 -->
      <svg viewBox="0 0 107 107" class="avatar-img avatar-placeholder">
        <defs>
          <clipPath id="avatar-circle">
            <circle cx="53.5" cy="53.5" r="53.5"/>
          </clipPath>
        </defs>
        <circle cx="53.5" cy="53.5" r="53.5" fill="#D8DEE5"/>
        <g clip-path="url(#avatar-circle)">
          <circle cx="53.5" cy="42" r="19" fill="#fff"/>
          <path d="M14 108 C14 80 32 66 53.5 66 C75 66 93 80 93 108 Z" fill="#fff"/>
        </g>
      </svg>
      <span class="login-text">请登录</span>
      <div class="auth-btns">
        <div class="auth-btn" @click="goLogin">登录</div>
        <div class="auth-btn" @click="goLogin">注册</div>
      </div>
    </div>

    <!-- 功能菜单（分组） -->
    <div class="menu-group" v-for="(group, gi) in groups" :key="gi">
      <div
        v-for="item in group"
        :key="item.title"
        class="menu-item"
        @click="handleClick(item)"
      >
        <img :src="getIcon(item.icon)" class="menu-icon" :alt="item.title" />
        <span class="menu-title">{{ item.title }}</span>
        <svg viewBox="0 0 24 24" class="menu-arrow">
          <path d="M9 5 L16 12 L9 19" fill="none" stroke="#c8c9cc" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { navigateWithLoading } from '@/utils/loading'

const iconContext = require.context('@/assets/icons', false, /\.png$/)
const icons = {}
iconContext.keys().forEach(key => {
  const name = key.replace(/^\.\//, '').replace(/\.png$/, '')
  icons[name] = iconContext(key)
})

export default {
  name: 'Mine',
  data() {
    return {
      loggedIn: localStorage.getItem('jszhrs_logged_in') === '1',
      groups: [
        [
          { title: '电子社保卡', icon: 'mine-card' }
        ],
        [
          { title: '我的社保', icon: 'mine-social' },
          { title: '我的培训', icon: 'mine-train' },
          { title: '我的信息', icon: 'mine-info' },
          { title: '我的办件', icon: 'mine-todo' },
          { title: '我的证照', icon: 'mine-cert' },
          { title: '我的材料', icon: 'mine-material' },
          { title: '我的文书', icon: 'mine-doc' },
          { title: '我的地址', icon: 'mine-address' },
          { title: '我的快递', icon: 'mine-express' }
        ],
        [
          { title: '分享APP', icon: 'mine-share' }
        ],
        [
          { title: '企业服务', icon: 'mine-company' }
        ]
      ]
    }
  },
  methods: {
    getIcon(name) {
      return icons[name] || ''
    },
    goSettings() {
      // APK WebView 页面首帧渲染有延迟，跳转时显示全局loading（约2s）
      navigateWithLoading('/settings', 2000)
    },
    // 头部证件号/箭头 → 账户信息页（带loading）
    goAccountInfo() {
      navigateWithLoading('/account-info', 2000)
    },
    // 「已实人」标签 → 我的认证页
    goCertification() {
      navigateWithLoading('/my-certification', 2000)
    },
    // 未登录头部「登录/注册」按钮 → 登录页
    goLogin() {
      navigateWithLoading('/login', 2000)
    },
    handleClick(item) {
      const routeMap = {
        '电子社保卡': '/e-card',
        '我的社保': '/my-social',
        '我的培训': '/my-training',
        '我的信息': '/my-info',
        '我的办件': '/my-todo',
        '我的证照': '/my-cert',
        '我的材料': '/my-material',
        '我的文书': '/my-doc',
        '我的地址': '/my-address',
        '我的快递': '/my-express',
        '分享APP': '/share-app',
        '企业服务': '/enterprise-service'
      }
      const path = routeMap[item.title]
      if (path) {
        navigateWithLoading(path, 2000)
      }
    }
  }
}
</script>

<style scoped>
.mine {
  background: #f7f7f7;
  min-height: 100%;
}

/* 头部：蓝绿渐变，高 378w */
.user-header {
  position: relative;
  height: calc(378 * var(--w));
  background: linear-gradient(180deg, #3896de 0%, #3eadb4 100%);
}
.setting-icon {
  position: absolute;
  top: calc(98 * var(--w));
  right: calc(45 * var(--w));
  width: calc(50 * var(--w));
  height: calc(50 * var(--w));
}
.avatar-img {
  position: absolute;
  left: calc(45 * var(--w));
  /* 头像在头部内垂直居中 */
  top: calc(136 * var(--w));
  width: calc(107 * var(--w));
  height: calc(107 * var(--w));
  /* 头像只保留圆形，四角透出头部渐变背景 */
  border-radius: 50%;
  object-fit: cover;
}
.user-detail {
  position: absolute;
  left: calc(178 * var(--w));
  /* 信息块（姓名行+证件号）在头部内垂直居中 */
  top: calc(126 * var(--w));
  right: calc(100 * var(--w));
}
.name-row {
  display: flex;
  align-items: center;
}
.name {
  font-size: calc(48 * var(--w));
  font-weight: bold;
  color: #fff;
  line-height: 1.2;
}
.real-tag {
  display: flex;
  align-items: center;
  margin-left: calc(26 * var(--w));
  color: #e8772e;
  font-size: calc(30 * var(--w));
}
.tag-icon {
  width: calc(40 * var(--w));
  height: calc(40 * var(--w));
  margin-right: calc(8 * var(--w));
}
.id-number {
  margin-top: calc(26 * var(--w));
  font-size: calc(32 * var(--w));
  color: #fff;
  line-height: 1.3;
}
/* 用户信息行右侧箭头：与头像垂直居中 */
.header-arrow {
  position: absolute;
  top: calc(213 * var(--w));
  right: calc(36 * var(--w));
  width: calc(40 * var(--w));
  height: calc(40 * var(--w));
}

/* 未登录头部：绿青渐变 */
.header-logout {
  background: linear-gradient(180deg, #57C0A6 0%, #2F9E96 100%);
}
.avatar-placeholder {
  border-radius: 50%;
}
.login-text {
  position: absolute;
  left: calc(178 * var(--w));
  /* 与头像同一水平线：top/height 与 .avatar-img 一致，flex 垂直居中后中心对齐头像中心 */
  top: calc(136 * var(--w));
  height: calc(107 * var(--w));
  display: flex;
  align-items: center;
  font-size: calc(48 * var(--w));
  font-weight: bold;
  color: #fff;
}
/* 登录/注册：白色描边胶囊按钮，与头像同一行 */
.auth-btns {
  position: absolute;
  right: calc(45 * var(--w));
  top: calc(136 * var(--w));
  height: calc(107 * var(--w));
  display: flex;
  align-items: center;
}
.auth-btn {
  height: calc(64 * var(--w));
  padding: 0 calc(38 * var(--w));
  margin-left: calc(28 * var(--w));
  display: flex;
  align-items: center;
  border: calc(2 * var(--w)) solid #fff;
  border-radius: calc(999 * var(--w));
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  font-size: calc(34 * var(--w));
  line-height: 1;
  cursor: pointer;
}

/* 菜单分组：白底通栏，组间 46w 灰缝 */
.menu-group {
  background: #fff;
  margin-bottom: calc(46 * var(--w));
}
.menu-group:last-child {
  margin-bottom: 0;
}
.menu-item {
  display: flex;
  align-items: center;
  height: calc(149 * var(--w));
  padding-left: calc(48 * var(--w));
  cursor: pointer;
  border-bottom: 1px solid #ebebeb;
}
.menu-item:last-child {
  border-bottom: none;
}
.menu-icon {
  width: calc(60 * var(--w));
  height: calc(60 * var(--w));
  object-fit: contain;
}
.menu-title {
  flex: 1;
  margin-left: calc(30 * var(--w));
  font-size: calc(42 * var(--w));
  color: #323233;
}
.menu-arrow {
  width: calc(27 * var(--w));
  height: calc(27 * var(--w));
  margin-right: calc(43 * var(--w));
}
</style>



// WEBPACK FOOTER //
// src/pages/Mine.vue